/*
    Add here your own custom javascript ‍‌‍‍‌​‍‍‍​⁠​‌​‌‍​‌‌‌‍​​​‌‍​​‌​‍​​‌‌‍​‌​‌‍​‌​​‍‌​​​‍​‌‌​‍‌​​‌‍​​‌‌‍​​‌‌‍​​​​﻿​‍‌‌‍​​‌‍​‍
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

// Global HTML escaping helper (define once)
window.escapeHtml = window.escapeHtml || function (str) {
  str = str == null ? '' : String(str);
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
};
